// Icons referenced by name from the course content.
import {
  Antenna,
  AudioLines,
  AudioWaveform,
  Ban,
  BookUser,
  Boxes,
  CircleAlert,
  CircleCheck,
  Code2,
  Compass,
  Database,
  Download,
  FileAudio,
  FileCode2,
  FileText,
  Fingerprint,
  Flame,
  Forward,
  GitBranch,
  GitCompareArrows,
  Globe,
  Hash,
  Hourglass,
  KeyRound,
  Layers,
  LifeBuoy,
  ListChecks,
  ListFilter,
  Lock,
  LockKeyhole,
  Map,
  MapPin,
  MessageSquareText,
  Network,
  PhoneCall,
  PhoneOff,
  Puzzle,
  Radio,
  ReceiptText,
  Repeat,
  Repeat2,
  Rocket,
  Route,
  Router,
  Scale,
  ScanText,
  Search,
  Server,
  ServerCrash,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldOff,
  Signpost,
  SlidersHorizontal,
  Smartphone,
  Snowflake,
  Sparkles,
  Split,
  Stethoscope,
  Tag,
  TerminalSquare,
  Timer,
  ToggleRight,
  Users,
  Variable,
  Workflow,
  Zap,
  Circle,
} from 'lucide-react';

const icons = {
  Antenna,
  AudioLines,
  AudioWaveform,
  Ban,
  BookUser,
  Boxes,
  CircleAlert,
  CircleCheck,
  Code2,
  Compass,
  Database,
  Download,
  FileAudio,
  FileCode2,
  FileText,
  Fingerprint,
  Flame,
  Forward,
  GitBranch,
  GitCompareArrows,
  Globe,
  Hash,
  Hourglass,
  KeyRound,
  Layers,
  LifeBuoy,
  ListChecks,
  ListFilter,
  Lock,
  LockKeyhole,
  Map,
  MapPin,
  MessageSquareText,
  Network,
  PhoneCall,
  PhoneOff,
  Puzzle,
  Radio,
  ReceiptText,
  Repeat,
  Repeat2,
  Rocket,
  Route,
  Router,
  Scale,
  ScanText,
  Search,
  Server,
  ServerCrash,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldOff,
  Signpost,
  SlidersHorizontal,
  Smartphone,
  Snowflake,
  Sparkles,
  Split,
  Stethoscope,
  Tag,
  TerminalSquare,
  Timer,
  ToggleRight,
  Users,
  Variable,
  Workflow,
  Zap,
};

export default function Icon({ name, ...props }) {
  const Cmp = icons[name] || Circle;
  return <Cmp {...props} />;
}
